export const LOAD_TRANSLATION_DATA = "LOAD_TRANSLATION_DATA";
export const RESET_TRANSLATION_DATA = "RESET_TRANSLATION_DATA";